import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import {
  fullsizeAbsolute,
  skeletonShimmerGradient,
} from '../../shared/style-settings'

export const useImageCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    imageWrapper: {
      [theme.breakpoints.down('md')]: {
        textAlign: 'center',
      },
      position: 'relative',
      '& .MuiCircularProgress-root': {
        width: '40px !important',
        height: '40px !important',
      },
    },

    imageArea: {
      borderRadius: 4,
      background: skeletonShimmerGradient,
      animationDuration: '5s',
      animationFillMode: 'forwards',
      animationIterationCount: 'infinite',
      animationName: '$imageLoadingAnimation',
      animationTimingFunction: 'linear',
      display: 'inline-box',
      overflow: 'hidden',
      position: 'relative',

      '& > div': {
        paddingTop: '98.323% !important',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: theme.palette.common.white,
      },
    },

    loaderHolder: {
      ...fullsizeAbsolute,
      width: '100%',
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
    },

    loader: {
      opacity: '0.4',
    },

    imgError: {
      width: '40px !important',
      height: '40px !important',
      margin: '0 auto 0 auto',
      opacity: '0.4',
      fontSize: 80,
      color: theme.palette.error.light,
    },
  })
)
